import React from 'react';
import { IDeliveryAddress } from '../../../interfaces/IDeliveryAddress';
import { IOrder } from '../../../interfaces/IOrder';
import { IOrderItem } from '../../../interfaces/IOrderItem';
import { IPaymentMethod } from '../../../interfaces/IPaymentMethod';
import { distanceBetweenDatesInFull } from '../../../utils/DistanceBetweenDatesInFull';
import CustomStep from '../CustomStep';
import * as S from './styles';

interface IntershipProps {
  estagio: number;
  order: Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress> | undefined;
    orderPayment: Partial<IPaymentMethod> & {
      companyPaymentMethod?: any;
    };
    items: Partial<IOrderItem>[];
  };
}

const Intership: React.FC<IntershipProps> = (props) => {
  const { estagio, order } = props;

  const {
    createdAt,
    startedAt,
    preparationStartAt,
    expectedDeliveryAt,
    deliveryEndedAt,
    expectedTookAt,
    tookAt,
    endedAt,
    readyToTookAt,
    scheduledDeliveryAt,
    deliveryStartedAt,
  } = order;

  const getCompletedHours = (string: string): string => {
    if (string) {
      const newDate = new Date(string);

      return `${(newDate.getHours() < 10 ? '0' : '') + newDate.getHours()}:${
        (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes()
      }`;
    }
    return '';
  };

  const StepsCase: React.FC = () => {
    switch (estagio) {
      case 0: // Pedido em aguardo
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aguardando"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress />
            <CustomStep estagio="Em preparo" />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep
              estagio={order.address ? 'Expedido' : 'Pronto para retirada'}
            />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep estagio="Finalizado" />
          </>
        );
      case 2: // Pedido negado
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aguardando"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="unchecked"
              estagio="Negado"
              momento={`${
                endedAt && distanceBetweenDatesInFull(endedAt)
              }, às ${getCompletedHours(endedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep
              estagio={order.address ? 'Expedido' : 'Pronto para retirada'}
            />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep estagio="Finalizado" />
          </>
        );
      case 3: // Pedido em preparação
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aceito"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Em preparo"
              momento={`${
                preparationStartAt &&
                distanceBetweenDatesInFull(preparationStartAt)
              }, às ${getCompletedHours(preparationStartAt!)}`}
            />
            <S.CustomLinearProgress />
            <CustomStep
              estagio={order.address ? 'Expedido' : 'Pronto para retirada'}
            />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep estagio="Finalizado" />
          </>
        );
      case 5: // Pedido em rota de entrega
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aceito"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Em preparo"
              momento={`${
                preparationStartAt &&
                distanceBetweenDatesInFull(preparationStartAt)
              }, às ${getCompletedHours(preparationStartAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              estagio="Expedido"
              typeIcon="checked"
              momento={`${
                deliveryStartedAt &&
                distanceBetweenDatesInFull(deliveryStartedAt)
              }, às ${getCompletedHours(deliveryStartedAt!)}`}
            />
            <S.CustomLinearProgress />
            <CustomStep estagio="Finalizado" />
          </>
        );
      case 6: // Pedido entregue
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aceito"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Em preparo"
              momento={`${
                preparationStartAt &&
                distanceBetweenDatesInFull(preparationStartAt)
              }, às ${getCompletedHours(preparationStartAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              estagio={deliveryStartedAt ? 'Expedido' : 'Pronto para retirada'}
              typeIcon="checked"
              momento={
                deliveryStartedAt || readyToTookAt
                  ? `${distanceBetweenDatesInFull(
                      deliveryStartedAt! || readyToTookAt!,
                    )}, às ${getCompletedHours(
                      deliveryStartedAt! || readyToTookAt!,
                    )}`
                  : ''
              }
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Finalizado"
              momento={`${
                endedAt && distanceBetweenDatesInFull(endedAt)
              }, às ${getCompletedHours(endedAt!)}`}
            />
          </>
        );
      case 9: // Pedido cancelado pela loja
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aceito"
              momento={`${
                endedAt && distanceBetweenDatesInFull(endedAt)
              }, às ${getCompletedHours(endedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Em preparo"
              momento={`${
                preparationStartAt &&
                distanceBetweenDatesInFull(preparationStartAt)
              }, às ${getCompletedHours(preparationStartAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            {!deliveryStartedAt ? (
              <>
                <CustomStep
                  typeIcon="unchecked"
                  estagio="Cancelado"
                  momento={`${
                    endedAt && distanceBetweenDatesInFull(endedAt)
                  }, às ${getCompletedHours(endedAt!)}`}
                />
                <S.CustomLinearProgress variant="determinate" value={0} />
                <CustomStep estagio="Finalizado" />
              </>
            ) : (
              <>
                <CustomStep
                  estagio="Expedido"
                  typeIcon="checked"
                  momento={`${
                    deliveryStartedAt &&
                    distanceBetweenDatesInFull(deliveryStartedAt)
                  }, às ${getCompletedHours(deliveryStartedAt)}`}
                />
                <S.CustomLinearProgress variant="determinate" value={100} />
                <CustomStep
                  typeIcon="unchecked"
                  estagio="Cancelado"
                  momento={`${
                    endedAt && distanceBetweenDatesInFull(endedAt)
                  }, às ${getCompletedHours(endedAt!)}`}
                />
              </>
            )}
          </>
        );
      case 11: // Pedido pronto para retirada na loja
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aceito"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Em preparo"
              momento={`${
                preparationStartAt &&
                distanceBetweenDatesInFull(preparationStartAt)
              }, às ${getCompletedHours(preparationStartAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              estagio="Pronto para retirada"
              typeIcon="checked"
              momento={`${
                readyToTookAt && distanceBetweenDatesInFull(readyToTookAt)
              }, às ${getCompletedHours(readyToTookAt!)}`}
            />
            <S.CustomLinearProgress />
            <CustomStep estagio="Finalizado" />
          </>
        );
      case 12: // Pedido pronto para retirada na loja
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aceito"
              momento={`${
                startedAt && distanceBetweenDatesInFull(startedAt)
              }, às ${getCompletedHours(startedAt!)}`}
            />
            <S.CustomLinearProgress variant="determinate" value={100} />
            <CustomStep
              typeIcon="checked"
              estagio="Em preparo"
              momento={`${
                preparationStartAt &&
                distanceBetweenDatesInFull(preparationStartAt)
              }, às ${getCompletedHours(preparationStartAt!)}`}
            />
            <S.CustomLinearProgress />
            <CustomStep
              estagio={order.address ? 'Expedido' : 'Pronto para retirada'}
            />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep estagio="Finalizado" />
          </>
        );
      default:
        return (
          <>
            <CustomStep
              typeIcon="checked"
              estagio="Aguardando"
              momento={`${
                createdAt && distanceBetweenDatesInFull(createdAt)
              }, às ${getCompletedHours(createdAt!)}`}
            />
            <S.CustomLinearProgress />
            <CustomStep estagio="Em preparo" />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep
              estagio={order.address ? 'Expedido' : 'Pronto para retirada'}
            />
            <S.CustomLinearProgress variant="determinate" value={0} />
            <CustomStep estagio="Finalizado" />
          </>
        );
    }
  };

  return <StepsCase />;
};

export default Intership;
